import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import "react-datepicker/dist/react-datepicker.css";
import {
  Button,
  Typography,
  Toolbar,
  Dialog,
  Slide,
  IconButton,
  AppBar,
  ButtonGroup,
  TextField,
  Grid,
  Checkbox,
  Modal,
  Box,
  FormControlLabel,
  Autocomplete,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LoadingIcon from "../../../../reusable-component/LoadingIcon";
import InputField from "../../../../reusable-component/InputField";
import generateAlias from "../../generateAlias";
import { useAxios } from "../../../../contexts/AxiosProvider";
import { PostgresApi } from "../../../../services/PostgresApi";
import { getEnvironmentConfig } from "../../../../constants/CloudConstant";

const styleLoading = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const nameRegex = /^[a-zA-Z0-9_]{1,35}$/;

const NodeModal_WriteToPostgres = ({
  open,
  handleClose,
  nodeId,
  nodeName,
  nodes,
  edges,
  changeNodeName,
  setNodes,
  workflow,
}) => {
  const INITIALSTATE = {
    format: "postgres",
    target: "database",
    instrument_name: workflow.engagement.engagementName,
    alias: generateAlias(nodeName, nodeId),
    df: "",
    sample_view: true,
    // database:
    //   workflow.engagement.clientEntity.domainEntity.domainName ===
    //   "Business Operations"
    //     ? "BusinessOperation"
    //     : workflow.engagement.clientEntity.domainEntity.domainName ===
    //       "Translational Research"
    //     ? "CapsidBusinessIntelligence"
    //     : "",
    database: getEnvironmentConfig().POSTGRES_DATABASE_WAREHOUSE,
    schema_name: "",
    table_name: "",
    mode: "overwrite",
    primary_key_exists: false,
    primary_key_columns: [],
  };

  const [schemaData, setSchemaData] = useState({
    schemas: [
      {
        schema_name: "",
      },
    ],
  });
  const [tableData, setTableData] = useState({});
  const [tableColumnData, setTableColumnData] = useState({
    columns: [
      {
        columnName: "",
      },
    ],
  });

  const { enqueueSnackbar } = useSnackbar();
  const axios = useAxios();
  const [formField, setFormField] = useState(INITIALSTATE);
  const [disableForm, setDisableForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableName, setTableName] = useState([]);
  const [toggleType, setToggleType] = useState("S3");
  const [headerName, setHeaderName] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);
  const [errors, setErrors] = useState({ stream_interval: "" });
  const [prevNodeName, setPrevNodeName] = useState("");
  const [aliasError, setAliasError] = useState("");
  const [searchText, setSearchText] = useState("");

  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const handleRefreshModalOpen = () => setRefreshModalOpen(true);
  const handleRefreshModalClose = () => setRefreshModalOpen(false);

  const handleHeaderChange = (obj) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === obj.header;
    });

    if (selectedIndex === -1 && obj.checked) {
      setHeaderName([...headerName, obj]);

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              header: obj.header,
              alias: obj.alias,
              checked: true,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && obj.checked) {
      setHeaderName((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: obj.checked,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: obj.checked,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && !obj.checked) {
      setHeaderName((current) =>
        current.filter((object) => {
          return object.header !== obj.header;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: false,
              alias: "",
              cast_datatype: "string",
              attribute_type: "static",
              default_value: "",
            };
          }

          return object;
        })
      );
    }
  };

  const store = JSON.parse(sessionStorage.getItem("allNodes"));

  const getLocalData = () => {
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            setPrevNodeName(node.step_name);
          }
        });
      });

      const isHeader = header.some((item) => item.header);
      if (isHeader) {
        const newArr = [];

        if (prevNodeName === "Join") {
          header.forEach((el) => {
            const exist = el.header.split(".").length;

            if (exist === 2) {
              const head = el.header.split(".")[1];
              newArr.push({ ...el, header: el.alias ? el.alias : head });
            }
          });
        }
        if (newArr.length > 0) {
          header = newArr;
        }

        const uniqueHeader = [];

        const uniqueArray = header.filter((element) => {
          const isDuplicate = uniqueHeader.includes(element.header);

          if (!isDuplicate) {
            uniqueHeader.push(element.header);
            return true;
          }

          return false;
        });

        const head = [];

        const newHeader = uniqueArray.map((el) => {
          return {
            ...el,
            header: el.alias ? el.alias : el.header,
            alias: el.alias ? "" : el.alias,
          };
        });

        newHeader.forEach((el) => {
          head.push({ label: el.header });
        });

        setHeaders(head);
        setFetchedHeader(newHeader);
      } else {
        setHeaders([]);
        setFetchedHeader([]);
      }
      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          const writePostgresData = {
            df: prev_alias,
            format: node.formField.write_postgres.format,
            target: node.formField.write_postgres.target,
            alias: generateAlias(nodeName, nodeId),
            sample_view: node.formField.write_postgres.sample_view,
            instrument_name: node.formField.write_postgres.instrument_name,
            mode: node.formField.write_postgres.mode,
            database: node.formField.write_postgres.database,
            schema_name: node.formField.write_postgres.schema_name,
            table_name: node.formField.write_postgres.table_name,
            primary_key_exists:
              node.formField.write_postgres.primary_key_exists,
            primary_key_columns:
              node.formField.write_postgres.primary_key_columns,
          };
          setFormField(writePostgresData);
          setHeaderName(node.headerName);
          setTempHeader(node.headerName);
          setFetchedHeader(node.fetchedHeader);
          setToggleType(node.toggleType);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    setToggleType("S3");
    getLocalData();
  }, [nodeId]);

  const sendFormData = {
    nodeId,
    nodeName,
    formField,
    disabled: false,
    step_name: nodeName,
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormField((prevState) => {
      let updatedState = { ...prevState, [name]: fieldValue };

      if (name === "alias") {
        if (!nameRegex.test(fieldValue)) {
          setAliasError("Special Characters are not Allowed");
        } else {
          setAliasError("");
        }
      }
      if (name === "mode_name") {
        updatedState.mode = value;
      }
      if (name === "schema_name") {
        updatedState.schema_name = value;
      }
      if (name === "primary_key_exists") {
        updatedState.primary_key_exists = value;
        if (!value) {
          updatedState.primary_key_columns = [];
        }
      }
      if (name === "primary_key_columns") {
        updatedState.primary_key_columns = value;
      }
      return updatedState;
    });
  };

  const handleResetForm = () => {
    setFormField({
      ...INITIALSTATE,
    });
  };

  useEffect(() => {
    if (store) {
      setTableName(
        store.map((node, i) => {
          if (node.nodeName !== "WriteToPostgres") {
            return node.formField.alias;
          }
        })
      );
    }
  }, []);

  const compareTwoArrayOfObjects = (
    first_array_of_objects,
    second_array_of_objects
  ) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    if (formField.schema_id === "" || formField.project_id === "") {
      enqueueSnackbar("Field is missing", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }

    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    let prev_alias;
    if (store && findSrcNodeId) {
      let header = [];

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
          }
        });
      });
    }

    const getAllNodes = JSON.parse(sessionStorage.getItem("allNodes") || "[]");

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem("allNodes", JSON.stringify(newFormData));
    }

    // let y_axis = 0;
    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        // y_axis = `${parseInt(el.position.y, 10)}`;
        el.data.label = formField.alias;
      }
    });

    const newHeaderName = [];

    // headerName.forEach((item) => {
    //   newHeaderName.push({ ...item, tableAlias: formField.alias });
    // });

    fetchedHeader.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (
            count <= connectedNodes.length &&
            node.id === connectedNodes[count]
          ) {
            node.position.x += 0.1;
            count++;
          }
          return node;
        })
      );
    }

    sessionStorage.setItem("updatedNodes", JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField: {
        write_postgres: {
          ...formField,
          df: prev_alias,
        },
        alias: formField.alias,
      },
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      fetchedHeader,
      toggleType,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    if (!errors.stream_interval) {
      setDisableForm(true);
    }
    sessionStorage.setItem("node", JSON.stringify(nodes));
    sessionStorage.setItem("edges", JSON.stringify(edges));

    const fetchNodesData = JSON.parse(
      sessionStorage.getItem("allNodes") || "[]"
    );
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem("allNodes", JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(
      sessionStorage.getItem("saved_node") || "[]"
    );
    getElements.push(nodeId);
    sessionStorage.setItem("saved_node", JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });

    const getAllNodes = JSON.parse(sessionStorage.getItem("allNodes"));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el["disabled"] = false;
      }
    });

    sessionStorage.setItem("allNodes", JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem("saved_node"));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem("saved_node", JSON.stringify(newSavedElement));
  };

  const handleChecked = (event) => {
    setFormField({ ...formField, sample_view: event.target.checked });
  };

  useEffect(() => {
    fetchPostgresSchemas();
  }, [nodeId]);

  useEffect(() => {
    if (formField.schema_name !== "")
      fetchPostgresTables(formField.schema_name);
  }, [formField.schema_name]);

  useEffect(() => {
    if (formField.table_name !== "")
      fetchPostgresColumns(formField.schema_name, formField.table_name);
  }, [formField.table_name]);

  const fetchPostgresSchemas = async () => {
    // const domainName = workflow.engagement.clientEntity.domainEntity.domainName;
    const DatabaseType = "Postgres";
    try {
      setLoading(true);
      const response = await PostgresApi.getPostgresSchemas(
        axios,
        DatabaseType
      );
      if (response.status === 200) {
        setSchemaData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchPostgresTables = async (schema) => {
    // const domainName = workflow.engagement.clientEntity.domainEntity.domainName;
    const DatabaseType = "Postgres";
    try {
      setLoading(true);
      const response = await PostgresApi.getPostgresTables(
        axios,
        schema,
        DatabaseType
      );
      if (response.status === 200) {
        setTableData(response.data);
        if (response.data.length === 0) {
          enqueueSnackbar(`No data found for this schema`, {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        }
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
    }
  };
  const fetchPostgresColumns = async (schema, table_name) => {
    // const domainName = workflow.engagement.clientEntity.domainEntity.domainName;
    const DatabaseType = "Postgres";
    try {
      setLoading(true);
      const response = await PostgresApi.getPostgresColumns(
        axios,
        schema,
        table_name,
        DatabaseType
      );
      if (response.status === 200) {
        setTableColumnData(response.data);
        if (response.data.length === 0) {
          enqueueSnackbar(`No data found for this schema`, {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        }
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        // onClose={handleClose}
        TransitionComponent={Transition}
        style={{ width: "70%", marginLeft: "30%" }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: "relative", backgroundColor: "#fff" }}>
            <Toolbar>
              <IconButton
                edge="start"
                onClick={handleClose}
                aria-label="close"
                sx={{ color: "#00043C" }}
              >
                <CloseIcon />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, color: "#00043C" }}
                variant="h6"
                component="div"
              >
                {nodeName}
              </Typography>
              <ButtonGroup
                variant="contained"
                aria-label="outlined primary button group"
              >
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  className="outlined-button-color"
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  disabled={disableForm}
                  className="button-color"
                >
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>

          <div style={{ margin: 20 }}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <InputField
                  name="alias"
                  label="Alias"
                  value={formField.alias}
                  onChange={handleInputChange}
                  size="small"
                  disabled
                  required
                  error={!!aliasError}
                  helperText={aliasError}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={formField.sample_view}
                      onChange={handleChecked}
                      disabled={disableForm}
                    />
                  }
                  label="Sample View"
                  sx={{ pt: 1 }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: 0 }}>
              <Grid item xs={4}>
                <TextField
                  name="instrument_name"
                  label="Instrument Name"
                  value={formField.instrument_name}
                  size="small"
                  disabled
                  required
                  fullWidth
                  InputProps={{
                    style: {
                      fontFamily: "'EB Garamond', serif ",
                      fontWeight: 600,
                    },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "'EB Garamond', serif " },
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  name="mode_name"
                  select
                  label="Mode"
                  value={formField.mode}
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                  required
                  fullWidth
                  InputProps={{
                    style: {
                      fontFamily: "'EB Garamond', serif ",
                      fontWeight: 600,
                    },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "'EB Garamond', serif " },
                  }}
                >
                  <MenuItem value={"overwrite"} key={"overwrite"}>
                    Overwrite
                  </MenuItem>
                  <MenuItem value={"append"} key={"append"}>
                    Append
                  </MenuItem>
                  <MenuItem value={"incremental"} key={"incremental"}>
                    Incremental
                  </MenuItem>
                  <MenuItem value={"upsert"} key={"upsert"}>
                    Upsert
                  </MenuItem>
                  <MenuItem value={"scd2"} key={"scd2"}>
                    scd2
                  </MenuItem>
                </TextField>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: 0 }}>
              <Grid item xs={4}>
                <TextField
                  name="database_name"
                  label="Database"
                  value={formField.database}
                  size="small"
                  disabled
                  required
                  fullWidth
                  InputProps={{
                    style: {
                      fontFamily: "'EB Garamond', serif ",
                      fontWeight: 600,
                    },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "'EB Garamond', serif " },
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: 0 }}>
              <Grid item xs={4}>
                <Autocomplete
                  options={schemaData.schemas}
                  getOptionLabel={(option) => option.schema_name}
                  value={
                    formField.schema_name
                      ? { schema_name: formField.schema_name }
                      : null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "schema_name",
                        value: newValue ? newValue.schema_name : "",
                      },
                    });
                  }}
                  inputValue={searchText}
                  onInputChange={(event, newInputValue) => {
                    setSearchText(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="schema_name"
                      label="Schema Name"
                      size="small"
                      disabled={disableForm}
                      required
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        style: {
                          fontFamily: "'EB Garamond', serif ",
                          fontWeight: 600,
                        },
                      }}
                      InputLabelProps={{
                        style: { fontFamily: "'EB Garamond', serif " },
                      }}
                    />
                  )}
                />
              </Grid>
              {formField.schema_name !== "" && (
                <Grid item xs={4}>
                  <TextField
                    name="table_name"
                    select
                    label="Table"
                    value={formField.table_name}
                    onChange={handleInputChange}
                    size="small"
                    disabled={disableForm}
                    required
                    fullWidth
                    InputProps={{
                      style: {
                        fontFamily: "'EB Garamond', serif ",
                        fontWeight: 600,
                      },
                    }}
                    InputLabelProps={{
                      style: { fontFamily: "'EB Garamond', serif " },
                    }}
                  >
                    {tableData[formField.schema_name]?.map((table) => {
                      return (
                        <MenuItem
                          value={table.table_name}
                          key={table.table_name}
                        >
                          {table.table_name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
              )}
            </Grid>
            {formField.table_name !== "" && (
              <Grid container spacing={2} sx={{ marginTop: 0 }}>
                <Grid item xs={4}>
                  <TextField
                    id="outlined-basic"
                    select
                    label="Primary Key Exists"
                    variant="outlined"
                    value={formField.primary_key_exists}
                    name="primary_key_exists"
                    onChange={handleInputChange}
                    size="small"
                    fullWidth
                    disabled={disableForm}
                    required
                    InputProps={{
                      style: {
                        fontFamily: "'EB Garamond', serif ",
                        fontWeight: 600,
                      },
                    }}
                    InputLabelProps={{
                      style: { fontFamily: "'EB Garamond', serif " },
                    }}
                  >
                    <MenuItem value={true}>true</MenuItem>
                    <MenuItem value={false}>false</MenuItem>
                  </TextField>
                </Grid>
                {formField.primary_key_exists === true && (
                  <Grid item xs={4}>
                    <TextField
                      id="outlined-basic"
                      select
                      label="Primary key columns"
                      variant="outlined"
                      value={formField.primary_key_columns || []}
                      name="primary_key_columns"
                      onChange={handleInputChange}
                      size="small"
                      disabled={disableForm}
                      required
                      fullWidth
                      SelectProps={{
                        multiple: true, // Enable multiple selection
                      }}
                    >
                      {tableColumnData.columns?.map((column) => {
                        return (
                          <MenuItem
                            value={column.columnName}
                            key={column.columnName}
                          >
                            {column.columnName}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                )}
              </Grid>
            )}
          </div>
          {loading && <LoadingIcon />}
        </form>
      </Dialog>
      <Modal
        open={refreshModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </div>
  );
};

export default NodeModal_WriteToPostgres;
